import React from 'react';
import { trackGA4AndNavigate } from '@gumtree/shared/src/util/ga4-shared';
import { getLinkHostname } from '@gumtree/shared/src/util/ga4-bff';
import Link from '../link/link';

export default function Breadcrumb({ name, index, url }: Props) {
    return (
        <li className="breadcrumbs-link">
            {url ? (
                <Link
                    href={url}
                    text={name}
                    onClick={(e) =>
                        trackGA4AndNavigate<GA4.ClickBreadcrumb>({
                            href: url,
                            mouseEvent: e,
                            payload: {
                                event: 'click_breadcrumb',
                                linkDomain: getLinkHostname(url),
                                linkText: name,
                                linkBreadcrumbLevel: `Level ${index + 1}`,
                                linkURL: url,
                            },
                        })
                    }
                />
            ) : (
                <span>{name}</span>
            )}
        </li>
    );
}

interface Props {
    name: string;
    /** 0-based index */
    index: number;
    url?: string;
}
